import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { readContract } from '@wagmi/core';
const abi = require('src/contracts/abi/pdogv2.json');
const migrationAbi = require('src/contracts/abi-dev/migrator.json');

@Injectable({
  providedIn: 'root'
})
export class V2ContractService {
  
  constructor() {}


  /**
   * Gets contract address
   */
  async getContractAddress(){
    return await readContract({
      address: environment.MIGRATOR_ADDRESS as any,
      abi: migrationAbi,
      functionName: 'getnewToken',
      args: []
    });
  }

  /**
   * Gets symbol
   * @param v2Address
   * @returns  
   */
  async getSymbol(v2Address) {
    const symbol = await readContract({
      address: v2Address,
      abi: abi,
      functionName: 'symbol',
      args: []
    })
    return symbol;
  }
}
